module.exports = __webpack_public_path__ + "static/Zasady-Wynajmu-Kserokopiarek-18c9a6244f2f620bcc59d18f403e61bb.png";